angular.module('rjmNg.directives').directive "inviteTeamMembers", [
  "Invites"
  "$routeParams"
  "$clientAppUrl"
  "notification"
  "$q"
  (
    Invites
    $routeParams
    $clientAppUrl
    notification
    $q
  ) ->
    restrict: "E"
    templateUrl: "directive.inviteTeamMembers.html"
    replace: false
    controllerAs: "view"
    bindToController: true
    require: "^?rjmUi"
    controller: [
      "$window"
      ($window) ->

        view = @

        view.init = ->
          view.loading = false

          view.connectDatabaseUrl = $clientAppUrl "/magento/database/mysql"

          view.hasSentInvitations = false

          view.invites = [
            email: null
          ]

        view.deleteMember = (index) ->
          view.invites.splice(index, 1);

        view.addNewInvite = ->
          view.invites.push email: null

        view.sendInvites = ->
          notification.clear('inviteMembersNotifications')
          erroredInvites = []
          promises = []
          view.loading = true
          view.invites.forEach (invite) ->
            data = 
              email: invite.email
              client_id: $routeParams.clientId
            deferred = $q.defer();
            Invites.createInvite(data)
              .then (response) ->
                deferred.resolve({success: true})
              .catch ({error}) ->
                deferred.resolve({
                  success: false
                  email: invite.email
                })
            promises.push(deferred.promise)

          $q.all(promises)
          .then (invites) ->
            invites.map (invite) -> 
              if (!invite.success)
                erroredInvites.push(invite.email)
            if (erroredInvites.length)
              errorMessage = "We were unable to invite #{erroredInvites.join(', ')}. Please try again."
              notification.error("Failed to send invites", errorMessage, "inviteMembersNotifications", { dismissable: false, bindHtml: false })
            else
              view.hasSentInvitations = true
            view.loading = false

        view.init()

        view
    ]
    link: (scope, element, attributes, rjmUi) ->
      scope.$watch "view.loading", () ->
        rjmUi?.loadingUi "inviteTeamMembers", scope.view.loading
]
